<div mat-dialog-title>
	<div>
		<h3>
			{{ locs.CMSystemLocalizationDialogDialogTitle | localize | async }}:
			{{ loc.displayPath }}
		</h3>
		<button
			mat-button
			color="warn"
			[attr.ariaLabel]="locs.CMSystemLocalizationDialogDelete | localize | async"
			(click)="remove()">
			<ats-icon name="trash"></ats-icon>
		</button>
	</div>
</div>

<div mat-dialog-content>
	@if (form) {
	<dl>
		<div>
			<dt>
				{{ locs.CMSystemLocalizationDialogSystemId | localize | async }}
			</dt>
			<dd>
				{{ loc.name }}
			</dd>
		</div>
		<div>
			<dt>
				{{ locs.CMSystemLocalizationDialogFeature | localize | async }}
			</dt>
			<dd>
				{{ loc.feature }}
			</dd>
		</div>
		<div class="description">
			<dt>
				{{ locs.CMSystemLocalizationDialogDescription | localize | async }}
			</dt>
			<dd>
				{{ loc.description }}
			</dd>
		</div>
		<div>
			<dt>
				{{ locs.CMSystemLocalizationDialogShared | localize | async }}
			</dt>
			<dd>
				{{ loc.shared || false | booleanDisplay | async }}
			</dd>
		</div>
		<div>
			<dt>
				{{ locs.CMSystemLocalizationDialogAllowHTML | localize | async }}
			</dt>
			<dd>
				{{ loc.htmlAllowed | booleanDisplay | async }}
			</dd>
		</div>
		<ng-container *ngIf="!loc.htmlAllowed">
			<div>
				<dt>
					{{ locs.CMSystemLocalizationDialogDefaultValue | localize | async }}
				</dt>
				<dd>
					{{ loc.defaultValue }}
				</dd>
			</div>
			<div>
				<dt>
					{{ locs.CMSystemLocalizationDialogCurrentValue | localize | async }}
				</dt>
				<dd>
					{{ currentValue$ | async }}
				</dd>
			</div>
		</ng-container>
	</dl>

	<form [formGroup]="form" (ngSubmit)="handleSubmit()">
		<mat-form-field>
			<mat-label>
				{{ locs.CMSystemLocalizationDialogCurrentLanguage | localize | async }}
			</mat-label>
			<mat-select formControlName="language">
				<mat-option *ngFor="let culture of cultures$ | async" [value]="culture.code">
					{{ culture.label }} ({{ culture.nativeLabel }})
				</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field *ngIf="!loc.htmlAllowed">
			<mat-label>
				{{ locs.CMSystemLocalizationDialogNewValue | localize | async }}
			</mat-label>
			<input type="text" matInput formControlName="value" class="loc-dialog-first" />
		</mat-form-field>

		<cm-html-localize-form
			*ngIf="loc.htmlAllowed"
			formControlName="value"
			[defaultValue]="loc.defaultValue"
			(codeEditorClose)="handleCodeChanges($event)"></cm-html-localize-form>
	</form>
	}
</div>

<div mat-dialog-actions>
	<button mat-dialog-close (click)="handleCancel()">
		{{ locs.CMSystemLocalizationDialogCancel | localize | async }}
	</button>
	<button color="primary" (click)="handleSubmit()">
		{{ locs.CMSystemLocalizationDialogSave | localize | async }}
	</button>
</div>
